import React from "react";
import axios from "axios";
import { connect } from "react-redux";
import { nameFormatter } from "../../utils";
import { ButtonSpan } from "../Button";
import { stopImpersonating, token } from "../../modules/auth";
import { refreshUser } from "../../modules/auth-thunks";

function ImpersonatingHeader({
  auth,
  token,
  impersonating,
  stopImpersonating,
  refreshUser,
}) {
  const originalAuth = auth.originalUser;
  if (!impersonating && !originalAuth) return null;

  const stopImpersonation = () => {
    return axios
      .post(
        `${window.API}/auth/impersonate/${auth.user.email}/stop`,
        {
          impersonator_user_id: originalAuth.user.id,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then(() => {
        localStorage.removeItem('hotelGroupsForAnalyticsResponse')
        localStorage.removeItem('venuesForHotelGroups')
        localStorage.removeItem('selectedGroups')
        stopImpersonating(originalAuth);
        refreshUser(true);
      })
      .catch(() => {
        alert("There was an error stopping impersonation.");
      });
  };

  return (
    <div className={"text-center bg-blue p-2 text-white text-sm"}>
      You are impersonating <strong>{nameFormatter(auth.user, false)}</strong>,
      logged in as <strong>{nameFormatter(originalAuth.user)}</strong>.{" "}
      <ButtonSpan onClick={() => stopImpersonation()}>
        Stop Impersonating
      </ButtonSpan>
    </div>
  );
}

export default connect(
  state => ({
    auth: state.auth,
    token: token(state),
    impersonating: state.auth.impersonating,
  }),
  { refreshUser, stopImpersonating }
)(ImpersonatingHeader);
